import React from 'react';

import {
  useReviews,
  useCreate,
  useIsUpdating,
  useRemove,
  useUpdate,
} from 'scenes/Gallery/GalleryPage/Concepts/Reviews/data';
import { ReviewsList } from 'scenes/Gallery/components/Reviews';

const ConceptReviewsList = ({ conceptId, columns, disableGutters }) => {
  const { data, isLoading, isRefetching } = useReviews(conceptId);

  const isUpdating = useIsUpdating();
  const [addReview] = useCreate();
  const [updateReview] = useUpdate();
  const [removeReview] = useRemove();

  const handleAddReview = ({ text, mark }) =>
    addReview({ parentId: conceptId, conceptId, text, mark });

  const handleEditReview = ({ id, comment: text, mark }) =>
    updateReview({ id, mark, text, conceptId });

  const handleRemoveReview = (review) => removeReview({ ...review, conceptId });

  return (
    <ReviewsList
      data={data}
      isLoading={isLoading || isUpdating}
      isRefetching={isRefetching}
      onAdd={handleAddReview}
      onEdit={handleEditReview}
      onRemove={handleRemoveReview}
      columns={columns}
      disableGutters={disableGutters}
    />
  );
};

export default ConceptReviewsList;
